import {PlayerBase} from "../../player/player.base";
import {Component, Injector} from '@angular/core';
import {GenericElm} from '../../player/generic.elm';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError, tap} from "rxjs/operators";
import {lastMap} from "../../rxjs/lastMap";
import {Expiration} from "../../interfaces/Expiration";

@Component({
  selector: 'app-ad-net',
  template: '<div #component></div>',
  styleUrls: []
})
export class AdNetComponent extends PlayerBase {
  genericElm: GenericElm;
  mode; // share, customer, package, content
  channel;
  defaultList;
  defaultMaxInterval;

  packageContents = {};
  contents = [];
  contentLength;
  contentValue;
  contentInfo;
  index = 0;
  timeOffset = 0;
  beginPlayTime = 0;
  defaultUrl;
  timeoutId;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        this.genericElm = new GenericElm(this.component);

        this.mode = this.data.AdNet[0].$.mode;

        switch (this.mode) {
          case "share":
            this.channel = Number(this.data.AdNet[0].$.channel);
            this.defaultList = this.data.AdNet[0].DefaultList[0].Default;
            this.defaultMaxInterval = Number(this.data.AdNet[0].$.defaultMaxInterval);

            this.defaultUrl = this.defaultList[0].$.url;
            //this.genericElm.setImage(img, false, this.actualWidth, this.actualHeight);
            break;
        }

        const url = "https://adnet.signage.me/adNetService.ashx?command=targetRequest&targetId=438267";
        return this.playerService.caching.requestText(url, 'adNet', Expiration.Minute);
      }),
      switchMap( str => {
        const data = JSON.parse(str)
        this.build(data);
        return of(self);
      }),
      catchError( err => this.logError(err) ),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  build(data) {
    let count = 0;
    let contentInfo;
    for (let i1 = 0; i1 < data.packages.length; ++i1) {
      const adPackage = data.packages[i1].Value;
      if (adPackage.deleted == true || adPackage.enabled == false)
        continue;
      if (adPackage.playMode != 0)
        continue;
      for (let i2 = 0; i2 < adPackage.contents.length; ++i2) {
        const content = adPackage.contents[i2];
        const contentId = content.Key;
        const contentValue = content.Value;

        if (contentValue.deleted)
          continue;

        this.packageContents[contentId] = contentValue;

        contentInfo = {}

        contentInfo.id = contentId;
        contentInfo.duration = contentValue.duration;
        contentInfo.max = Math.min(3600, contentValue.duration * contentValue.reparationsPerHour);
        contentInfo.actual = 0;

        this.contents.push(contentInfo);
        count++;
      }
    }


    let total = 3600;

    while (count > 0 && total > 0) {
      var cup = total / count;
      for (let i3 = 0; i3 < this.contents.length; ++i3) {
        contentInfo = this.contents[i3]
        var empty = contentInfo.max - contentInfo.actual;
        if (empty == 0)
          continue;
        var add = Math.min(empty, cup);
        contentInfo.actual += add;
        total -= add;
        if (contentInfo.max == contentInfo.actual)
          count--;
      }
    }


    for (let i3 = 0; i3 < this.contents.length; ++i3) {
      contentInfo = this.contents[i3];
      contentInfo.rep = contentInfo.actual / contentInfo.duration;
      contentInfo.interval = 3600 / contentInfo.rep;
      contentInfo.count = 0;
      contentInfo.totalTime = 0;
      contentInfo.totalTimeArea = 0;
    }

    this.contentLength = this.contents.length;

    this.nextPackageContent();
  }



  nextPackageContent() {
    this.endPlay();
    this.contentValue = null;
    if (this.contentLength > 0)
    {
      const date = new Date();
      const seconds = date.getTime() / 1000 - this.timeOffset;

      for (let i = 0; i < this.contentLength; ++i) {
        this.index++;
        if (this.index >= this.contentLength) {
          this.index = 0;
        }

        this.contentInfo = this.contents[this.index];
        if ((this.contentInfo.count * this.contentInfo.interval) < seconds) {
          this.contentInfo.count++;
          this.contentValue = this.packageContents[this.contentInfo.id];
          break;
        }
      }
    }

    if (this.contentValue != null) {

      this.playContent(this.contentValue.contentUrl);

      this.beginPlay();
      this.timeoutId = setTimeout(()=> {
        clearTimeout(this.timeoutId );
        this.timeoutId = null;
        this.nextPackageContent();
      }, this.contentInfo.duration * 1000);
    }
    else {
      this.playContent(this.defaultUrl);
      //??? window.setTimeout(nextPackageContent, 10000);
    }
  }



  beginPlay() {
    const d1 = new Date();
    this.beginPlayTime = d1.getTime() / 1000;
  }


  endPlay() {
    if (this.contentValue != null) {
      const d2 = new Date();
      const duration = d2.getTime() / 1000 - this.beginPlayTime;
      /*???
      var url = 'https://adnet.signage.me/adNetService.ashx?command=bannerFlush&targetId=' + m_targetId +
        '&channel=' + m_channel + '&contentId=' + m_contentInfo.id + '&duration=' + duration + "&timezoneOffset=" + timezoneOffset;
      $.getJSON(url,
        function (data2) {
          alert("stat");
        });
*/
      this.contentValue = null;
    }

  }



  playContent(i_src) {
    this.genericElm.setMedia(i_src, false, this.actualWidth, this.actualHeight, null, null);
  }

  destroy(): void {
    if (this.timeoutId != null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    super.destroy();
  }
}
